import { units } from '@ui/css';
import { makeSelectors, combineTokens } from '@utils/css';
import { colors } from '../../../design-tokens/colors.js';

const tabUnderlineTokens = combineTokens("--tab-underline", {
  color: colors.accent,
  width: units.px(4)
});
const underlineCls = "dibu1qwcp1f";
const tabUnderlineSelectors = makeSelectors({
  underline: underlineCls
});

export { tabUnderlineSelectors, tabUnderlineTokens, underlineCls };
import "./styles.linaria.module.css";
//# sourceMappingURL=styles.js.map
